import React from "react";
import { isFullArray } from "@obby/lib";
import ImageBulletPoints from "../ImageBulletPoints";
import { Box } from "./BulletPointSalesBox.layout";

export function BulletPointSalesBox({
  size,
  title,
  description,
  points,
  titleCss
}) {
  return (
    <Box variant="salesBox" componentname="bullet-point-sales-box">
      <Box
        variant="title"
        componentname="bullet-point-sales-box__title"
        fontSize={size || "medium"}
        css={titleCss}
        className={`bullet-point-sales-box__title bullet-point-sales-box__title--${size ||
          "medium"} `}
      >
        {title}
      </Box>
      <Box
        variant="description"
        componentname="bullet-point-sales-box__description"
        className="bullet-point-sales-box__description"
      >
        {description}
      </Box>

      {isFullArray(points) && <ImageBulletPoints points={points} />}
    </Box>
  );
}
